<template>
    <dynamic-modal
        @apply-cb="apply"
        btn-position="left"
        :name="'delete-gate-modal'"
        :title="title">
      <template #body>
        <p>Are you sure you want to delete this gate? All information will be permanently deleted.</p>
      </template>
    </dynamic-modal>
</template>
<script>
import DynamicModal from "@/components/__new_ui_kit/Modal/DynamicModal";
export default {
  components: {DynamicModal},
  props: {
    title: String,
    name: String,
    deleteId: {type: Number, required: true},
    updateList: {type: Function}
  },
  methods: {
    async apply(applyCb) {
      try {
        await this.deleteModal(this.$props.deleteId)
        await this.$store.dispatch('createNotification', {
          type: 'success',
          message: `Gate successfully deleted`})
        applyCb()
      } catch (e) {
        // todo общий обработчик ошибок
        console.error(e)
        await this.$store.dispatch('createNotification', {
          type: 'danger',
          message: 'Something wrong'
        })
        applyCb(true)
      }
    },
    deleteModal(id) {
      // todo переписать эту логику, осталась со старых времен)
      return this.$store.dispatch('deleteContent', id)
          .then(resp => {
            return this.$props.updateList()
          })
          .catch((error)=>{
            throw(error)
          })
    },
  }
}
</script>